import { useAuthContext } from "../../context/authcontext";
import { apiCall } from "../api/api";

const useRefreshToken = () => {
  const { updateTokenInfo, fullToken } = useAuthContext();

  const refresh = async () => {
    const response = await apiCall.post("/account/RefreshToken", fullToken);
    updateTokenInfo(response.data);
    return response.data.token;
  };

  return refresh;
};

export default useRefreshToken;
